import { SpeechBox } from 'entities/SpeechBox';
import Robot from 'shared/assets/img/speakers/robot.png';
import { ReactNode, useEffect, useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { AppLink, AppLinkTheme } from 'shared/ui/AppLink/AppLink';
import cls from './AssistantOverlay.module.scss';

interface AssistantOverlayProps {
    switcher?: boolean;
    message: string;
    section?: string;
    buttonsCount?: number;
    buttonText?: string;
    cb?: (value: boolean) => void;
    children?: ReactNode;
}

export const AssistantOverlay = ({ switcher, message, children, section, buttonsCount, buttonText, cb }: AssistantOverlayProps) => {
    const [switchState, setSwitchState] = useState(switcher);

    useEffect(() => {
        setSwitchState(switcher);
    }, [switcher])

    return (
        <div className={cls.assistantPage}>
            <div className={cls.children}>
                {children}
            </div>
            {
                switchState && (
                    <div>
                        <div className={cls.speechBox}>
                            <div className={cls.imgBox}>
                                <img className={cls.img} src={Robot} alt="Персонаж" />
                            </div>
                            <SpeechBox buttonsCount={buttonsCount} name="Помощник" message={message} />
                        </div>
                        <div className={cls.buttons}>
                            <Button
                                className={cls.button}
                                theme={ButtonTheme.NEXT}
                                onClick={() => {
                                    setSwitchState(!switcher);

                                    if (cb) {
                                        cb(!switcher);
                                    }

                                    if (section) {
                                        sessionStorage.setItem(section, 'Скрыть');
                                    }
                                }}
                            >
                                {buttonText ?? 'Далее'}
                            </Button>
                            {
                                buttonsCount && (
                                    <AppLink
                                        className={cls.button}
                                        theme={AppLinkTheme.NEXT}
                                        to="/plot"
                                        onClick={() => sessionStorage.setItem(section, 'Скрыть')}
                                    >
                                        Пропустить
                                    </AppLink>
                                )
                            }
                        </div>
                        <div className={cls.overlay} />
                    </div>
                )
            }
        </div>
    );
};
